// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QgQn","content":"styles_content__1Yv7n"};